import "./help-component.scss";
import m from "mithril";
import tools from "../../tools/tools";
import pf from "../../pf";
import {Icons, Icon, Size} from "../../plugins/construct-ui/index";
import infinite from "../../tools/infinite";
import playerwrapper from "./player-wrapper";

export default () => {
	let selectedVideoID = null;
	let pagecode = null;
	let videos = [];
	let search = undefined;
	let pagesearch = undefined;
	let loading = false;
	let searchedvideos = [];
	let searching = false;
	let editsection = false;

	let ilist = infinite(
		(data, options, index) => {
			let pinned = data.pinned == "1";
			return m(".help-link", [
				m(
					".linked-link",
					{
						class: pinned ? "pinned-pin" : "unpinned-pin",
						onclick: () => {
							if (pinned) {
								UnPinVideo(data);
							} else {
								PinVideo(data);
							}
						},
					},
					data.title
				),
			]);
		},
		(pagenum, pagesize, search, callback) => {
			let lastid = ilist.minmax()[pagenum - 1]?.max || "";
			pf.APIAction("GetData", {
				code: "videos",
				lastid,
				pagenum,
				pagesize,
				search,
				edit: true,
			}).then((r) => {
				callback({rows: r.data, rowscount: r.rowscount, idcol: "id"});
			});
		},
		10,
		2
	);
	let ilistComp = ilist.component();

	async function loadvideos() {
		loading = true;
		videos = [];
		await pf.APIAction("GetData", {code: "videos", pagecode}).then((r) => {
			if (r.success) {
				// console.log("loading videos result", r);
				videos = r.data || [];
				// console.log({videos});
			}
			loading = false;
			m.redraw();
		});
	}
	async function PinVideo(video) {
		let tempVideos = [...videos];
		videos.push(video);
		ilist.updatedata("id", video.id, {
			pinned: true,
		});
		pf.APIAction("GetData", {
			code: "videos",
			pagecode,
			uid: video.uid,
			pin: true,
		}).then((r) => {
			if (!r.success) {
				videos = [...tempVideos];
				ilist.updatedata("id", video.id, {
					pinned: false,
				});
			}
		});
	}

	async function UnPinVideo(video, index) {
		let tempVideos = [...videos];
		ilist.updatedata("id", video.id, {
			pinned: false,
		});
		videos = videos.filter((a) => a.uid != video.uid);
		pf.APIAction("GetData", {
			code: "videos",
			pagecode,
			uid: video.uid,
			pin: false,
		}).then((r) => {
			if (!r.success) {
				videos = [...tempVideos];
				ilist.updatedata("id", video.id, {
					pinned: true,
				});
			}
		});
	}

	async function performsearch() {
		// console.log("searching");
		searching = true;
		ilist.setsearch(pagesearch);
	}

	return {
		oninit: (v) => {
			// console.log(v.attrs.pagecode);
			pagecode = v.attrs.pagecode;
			loadvideos();
		},
		view: (v) => {
			return m(
				".help-component-wrapper",
				{
					class: selectedVideoID ? "show-player" : editsection ? "edit-section" : "show-list",
				},
				[
					selectedVideoID
						? []
						: [
								m(".title-row", [
									m(".help-title", "Help"),
									v.attrs.helpEditEnabled && [
										editsection &&
											tools.Button("Create New Recoding", Icons.PLUS_CIRCLE, undefined, () => {
												if (v.attrs.onstartrecording) v.attrs.onstartrecording();
											}),
										editsection
											? tools.Button("Exit Edit", Icons.X, undefined, () => {
													editsection = !editsection;
													if (editsection) ilist.reset();
											  })
											: tools.Button("Close Help Section", Icons.X_CIRCLE, undefined, () => {
													if (v.attrs.onclose) v.attrs.onclose();
											  }),
									],
								]),
								!editsection &&
									m(".top-row-section", [
										tools.Text(
											search,
											(w) => {
												search = w;
											},
											"search",
											m(Icon, {name: Icons.SEARCH}),
											searching ? m(Icon, {name: Icons.LOADER}) : undefined,
											{
												size: Size.LG,
											}
										),
										v.attrs.helpEditEnabled &&
											tools.Button(
												editsection ? "Exit Edit" : "Manage Videos for this Page",
												editsection ? Icons.X : Icons.EDIT,
												undefined,
												() => {
													editsection = !editsection;
													if (editsection) ilist.reset();
												}
											),
									]),

								editsection
									? m(".video-page-editor", [
											m(".edit-long-list", [
												m(".side-title", "List of Videos"),
												tools.Text(
													pagesearch,
													(w) => {
														pagesearch = w;
														performsearch();
													},
													"search",
													m(Icon, {name: Icons.SEARCH}),
													searching ? m(Icon, {name: Icons.LOADER}) : undefined,
													{
														size: Size.MD,
													}
												),
												m(ilistComp),
											]),
											m(".separator", m(Icon, {name: Icons.ARROW_RIGHT_CIRCLE})),
											m(".list-of-selected-videos", [
												m(".side-title", "Pinned Videos"),
												tools.Text(
													search,
													(w) => {
														search = w;
													},
													"search",
													m(Icon, {name: Icons.SEARCH}),
													searching ? m(Icon, {name: Icons.LOADER}) : undefined,
													{
														size: Size.MD,
													}
												),
												m(".selected-wrapper", [
													m(".expandable-container", [
														videos
															.filter((a) => {
																return pf.regexContains(a.title, search);
															})
															.map((a, i) => {
																return m(".help-link", [
																	m(
																		".linked-link.pinned-case",
																		{
																			onclick: () => {
																				UnPinVideo(a);
																			},
																		},
																		a.title
																	),
																]);
															}),
													]),
												]),
											]),
									  ])
									: m(".list-of-videos", [
											loading
												? tools.Spinner("Loading")
												: videos
														.filter((a) => {
															return pf.regexContains(a.title, search);
														})
														.map((a, i) => {
															return m(
																".help-link",
																{
																	onclick: () => {
																		selectedVideoID = a.uid;
																	},
																},
																[
																	m(".video-link", a.title),
																	// tools.Button("", Icons.CHECK_CIRCLE, undefined, () => {}, false, {
																	// 	class: "pinned-pin",
																	// }),
																]
															);
														}),
									  ]),
						  ],
					selectedVideoID &&
						m(playerwrapper, {
							uid: selectedVideoID,
							onstop: () => {
								// console.log("0");
								selectedVideoID = undefined;
								m.redraw();
							},
						}),
				]
			);
		},
	};
};
